import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenHarvestDeleteAction from './communityGardenHarvestDelete.action.json' with { type: 'json' }
import { communityGardenHarvestObject } from '../../communityGardenHarvestObject'

const communityGardenHarvestDeleteDefinition = defineAction({
  ...communityGardenHarvestDeleteAction,

  input: z.object({ id: communityGardenHarvestObject.shape.id }),
  output: z.object({}),
})

export default communityGardenHarvestDeleteDefinition
